export default __webpack_public_path__ + "static/media/Digital_Page.029d3bbd.svg";